import { getFarmPath } from '@/util/app.js'

export default {
  computed: {
    options () {
      return this.items
        .map(item => ({
          id: item.id,
          title: item.title,
          path: getFarmPath(null, this.$route, item.path)
        }))
    }
  }
}
